import { useMutation } from '@tanstack/react-query';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  IUpdateUserRoleParams,
  IUserParams,
} from 'apis/GraphQL/Variables/user';
import RoleApi from 'apis/RoleApis';
import { UserApi } from 'apis/UserApis';
import { ButtonFilter } from 'components';
import { useTitle } from 'contexts/TitleProvider';
import useQueryParam from 'hooks/useQueryPrams';
import { IRole } from 'interfaces/Role/Role';
import { IUserPermission } from 'interfaces/User/User';
import { DEFAULT_PAGE_SIZE } from 'utils/constants/constant';
import { toastError, toastSuccess } from 'utils/constants/functions';
import FilterPermission from './FilterPermission';
import ModalPermission from './ModalPermission';
import TablePermission from './TablePermission';
import RoleJobTitleApis from 'apis/RoleJobTitleApis';
import { PlantApi } from 'apis/PlantApis';

type IFilter = Omit<IUserParams, 'page' | 'pageSize'>;
export const rolesBase = [
  { id: 1, name: 'admin', title: 'Admin' },
  { id: 2, name: 'ho', title: 'Hội sở' },
  { id: 3, name: 'cn', title: 'Chi nhánh' },
  { id: 3, name: 'sale', title: 'Bán hàng' },
  { id: 3, name: 'nvtq', title: 'Nhân viên thủ quỹ' },
  { id: 3, name: 'nvtk', title: 'Nhân viên thủ kho' },
  { id: 4, name: 'pc', title: 'Pháp chế' },
];

export interface ITableUserPermission {
  items: IUserPermission[];
  pageInfo?: any;
}

const initialState: ITableUserPermission = {
  items: [],
};

function PermissionPage() {
  const navigate = useNavigate(),
    { setTitle, setBreadcrumb } = useTitle();
  const [jobTitle, setjobTitle] = useState<any>([]);
  const [dataPlant, setDataPlant] = useState<any>([{}]);

  const [isOpenFilter, setIsOpenFilter] = useState(false),
    [editIndex, setEditIndex] = useState<number>(),
    [isOpenModal, setIsOpenModal] = useState(false);

  const [roles, setRoles] = useState<IRole[]>([]),
    [filter, setFilter] = useState<IFilter>(),
    [users, setUsers] = useState<ITableUserPermission>(initialState),
    [userModal, setUserModal] = useState<IUserPermission>(
      {} as IUserPermission,
    );
  const [dataRoleBase, setDataRoleBase] = useState<any>([]);
  const queryParam = useQueryParam(),
    page = parseInt(queryParam.get('page') + '') || 1,
    page_size = parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const { isPending: loadingAllrole, mutate: getAllRole } = useMutation({
      mutationFn: () => RoleApi.getAllRoleByFilter({}),
      onSuccess: (res) => {
        const items = res.data.getRole.items;
        setRoles(items);
      },
      onError: (error) => {
        console.log(error);
      },
    }),
    { isPending: getAllUserLoading, mutate: getAllUser } = useMutation({
      mutationFn: (params: IUserParams) => UserApi.getAllUser(params),
      onSuccess: (res) => {
        const data = res.data.getUser;
        setUsers(data);
      },
      onError: (error) => {
        console.log(error);
      },
    }),
    { isPending: getAllRoleComboboxLoading, mutate: getAllRoleCombobox } =
      useMutation({
        mutationFn: () => RoleApi.getAllRoleComboBox(),
        onSuccess: (res) => {
          setDataRoleBase(res.data.getRole.items);
        },
        onError: (error) => {
          console.log(error);
        },
      }),
    { isPending: getAllJobTitleLoading, mutate: getAllJobTitle } = useMutation({
      mutationFn: () => RoleJobTitleApis.getJobTitleComboBox(),
      onSuccess: (res) => {
        const items = res.data.getJobTitle.items;
        setjobTitle(items);
      },
      onError: (error) => {
        console.log(error);
      },
    });

  const { isPending: updateLoadding, mutateAsync: updateUserRoleAsync } =
    useMutation({
      mutationFn: (params: IUpdateUserRoleParams) =>
        UserApi.updateUserRole(params),
    });

  const { mutate: getPlant } = useMutation({
    mutationFn: () => PlantApi.getAllPlant(),
    onSuccess: (res) => {
      setDataPlant(
        res.data.getPlant.items
          ? res.data.getPlant.items.map((item: any) => ({
              value: item.id,
              label: item.id,
            }))
          : [],
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    setTitle('Phân quyền');
    setBreadcrumb([{ title: 'Hệ thống' }, { title: 'Phân quyền' }]);

    getPlant();
    getAllRole();
    getAllJobTitle();
    getAllRoleCombobox();
    getAllUser({
      page: page,
      pageSize: page_size,
    });
  }, []);

  useEffect(() => {
    const params: IUserParams = { page: page, pageSize: page_size, ...filter };
    getAllUser(params);
  }, [page, page_size, filter]);

  useEffect(() => {
    if (editIndex === undefined) return;

    const data = users.items[editIndex];
    setUserModal(data);
  }, [editIndex]);

  const handleFilter = (values: any) => {
    navigate(`?page=1&page_size=${page_size}`);
    const trimmedValues = {
      ...values,
      fullName: values?.fullName?.trim(),
      email: values?.email?.trim(),
      jobTitle: values?.jobTitle?.trim(),
      role: values?.role?.trim(),
    };
    setFilter(trimmedValues);
  };

  const handleModalEdit = async (values: any) => {
    if (editIndex === undefined) return;
    // if (!values.role) {
    //   toastError('Vui lòng chọn quyền');
    //   return;
    // }

    const params: IUpdateUserRoleParams = {
      id: users.items[editIndex].id,
      role: values.role,
      email: values.email,
      plantCode: values.plantCode,
      fullName: values.fullName,
    };

    try {
      // Cập nhật user role (bảng user)
      await updateUserRoleAsync(params);

      // 4) Hoàn tất
      setIsOpenModal(false);
      setEditIndex(undefined);
      toastSuccess('Cập nhật thành công');
      const refreshParams: IUserParams = {
        page: page,
        pageSize: page_size,
        ...filter,
      };
      getAllUser(refreshParams);
    } catch (e) {
      console.log(e);
      toastError('Cập nhật thất bại!');
    }
  };

  return (
    <>
      <Row gutter={[8, 16]} align={'middle'} justify={'end'}>
        <Col>
          <ButtonFilter isOpen={isOpenFilter} setIsOpen={setIsOpenFilter} />
        </Col>
      </Row>
      <FilterPermission
        jobTitles={jobTitle}
        setFilter={setFilter}
        roles={roles}
        open={isOpenFilter}
        onFinish={handleFilter}
        setIsOpenFilter={setIsOpenFilter}
      />
      <TablePermission
        loading={
          loadingAllrole ||
          updateLoadding ||
          getAllUserLoading ||
          getAllJobTitleLoading ||
          getAllRoleComboboxLoading
        }
        data={users}
        setEditIndex={setEditIndex}
        setOpenModal={setIsOpenModal}
      />
      <ModalPermission
        // roles={roles}
        roleBase={dataRoleBase}
        branch={dataPlant}
        data={userModal}
        open={isOpenModal}
        title={'Chỉnh sửa phân quyền'}
        setOpen={setIsOpenModal}
        onFinish={handleModalEdit}
      />
    </>
  );
}

export default PermissionPage;
